import { IFormType } from "./types";
import { submit_phase_index } from "./constants"
export const formStructure: IFormType = {
    startIndex: 100,//5
    pages: {
        [100]: {
            id: "userType",
            title: "form-strings.info-page.title",
            operation: {
                type: "INFO-PAGE",
                header: "form-strings.info-page.welcome",
                information: [
                    "form-strings.info-page.report",
                    "form-strings.info-page.follow-up",
                    "form-strings.info-page.book"
                ],
                next: {
                    valueSource: ["value"],
                    cases: {
                        default: 0
                    },
                    autoNext: {
                        allAutoNext: false
                    }
                },
            }
        },
        0: {
            id: "userType",
            title: "form-strings.user-type.help-with",
            operation: {
                type: "CARD-TO-LIST",
                options: [
                    {
                        option: {
                            name: "form-strings.user-type.private-person",
                            id: "privatePerson",
                            icon: "PERSON"
                        },
                        description: "form-strings.user-type.help-private-person",
                        suggestions: [
                            { "text": "form-strings.user-type.villa", key: "VIL" },
                            { "text": "form-strings.user-type.vacation-home", key: "FRI" },
                            { "text": "form-strings.user-type.apartment", key: "KOM" },
                            { "text": "form-strings.user-type.agriculture", key: "LAN" }
                        ]
                    },
                    {
                        option: {
                            name: "form-strings.user-type.real-estate",
                            id: "realEstate",
                            icon: "REALESTATE"
                        },
                        description: "form-strings.user-type.nomor-agreement",
                        suggestions: [
                            { "text": "form-strings.user-type.yes", key: "estateNomorAgreementYes" },
                            { "text": "form-strings.user-type.no", key: "estateNomorAgreementNo" },
                        ]
                    },
                    {
                        option: {
                            name: "form-strings.user-type.municipality",
                            id: "municipality",
                            icon: "MUNICIPALITY"
                        },
                        description: "form-strings.user-type.nomor-agreement",
                        suggestions: [
                            { "text": "form-strings.user-type.yes", key: "municiNomorAgreementYes" },
                            { "text": "form-strings.user-type.no", key: "municiNomorAgreementNo" },
                        ]
                    },
                    {
                        option: {
                            name: "form-strings.user-type.company",
                            id: "company",
                            icon: "BUSINESS"
                        },
                        description: "form-strings.user-type.nomor-agreement",
                        suggestions: [
                            { "text": "form-strings.user-type.yes", key: "companyNomorAgreementYes" },
                            { "text": "form-strings.user-type.no", key: "companyNomorAgreementNo" }
                        ]
                    }
                ],
                next: {
                    valueSource: ["value"],
                    cases: {
                        "VIL": 3,
                        "FRI": 3,
                        "KOM": 4,
                        "LAN": 3,
                        "estateNomorAgreementYes": 10,
                        "estateNomorAgreementNo": 11,
                        "municiNomorAgreementYes": 10,
                        "municiNomorAgreementNo": 11,
                        "companyNomorAgreementYes": 12,
                        "companyNomorAgreementNo": 26,
                        default: submit_phase_index
                    },
                    autoNext: {
                        allAutoNext: false,
                        shouldAutoNext: [
                            "estateNomorAgreementYes",
                            "estateNomorAgreementNo",
                            "municiNomorAgreementYes",
                            "municiNomorAgreementNo",
                            "companyNomorAgreementYes",
                            "companyNomorAgreementYes",
                            "VIL",
                            "FRI",
                            "KOM",
                            "LAN"],
                    }
                },
            }
        },
        1: {
            id: "municipalityOrCompany",
            title: "form-strings.municipality-or-company.help-with",
            operation: {
                type: "LIST-INPUT",
                description: "form-strings.municipality-or-company.choice",
                suggestions: [],
                next: {
                    valueSource: ["value"],
                    cases: {
                        default: 13
                    },
                    autoNext: {
                        allAutoNext: true,
                        shouldAutoNext: [],
                    }
                }

            }
        },
        2: {
            id: "insuranceChoice",
            title: "form-strings.insurance-info.help-with",
            operation: {
                type: "LIST-INPUT",
                description: "form-strings.insurance-info.choice",
                suggestions: [],
                next: {
                    valueSource: ["value"],
                    cases: {
                        default: 5
                    },
                    autoNext: {
                        allAutoNext: true,
                        shouldAutoNext: [],
                    }
                }
            }
        },
        3: {
            id: "pestType",
            title: "form-strings.pests.help-with",
            operation: {
                type: "LIST-INPUT",
                description: "form-strings.pests.choice",
                suggestions: [
                    { "text": "form-strings.pests.MYR", key: "MYR" },
                    { "text": "form-strings.pests.MOSS", key: "MÖS" },
                    { "text": "form-strings.pests.SIL", key: "SIL" },
                    { "text": "form-strings.pests.MAL", key: "MAL" },
                    { "text": "form-strings.pests.MOT", key: "MOT" },
                    { "text": "form-strings.pests.FLU", key: "FLU" },
                    { "text": "form-strings.pests.KAC", key: "KAC" },
                ],
                next: {
                    valueSource: ["value"],
                    cases: {
                        default: 19
                    },
                    autoNext: {
                        allAutoNext: true,
                        shouldAutoNext: [],
                    }
                }
            }
        },
        4: {
            id: "condominiumOrTenancy",
            title: "form-strings.condominium-or-tenancy.help-apartment-type",
            operation: {
                type: "LIST-INPUT",
                description: "form-strings.condominium-or-tenancy.help-with",
                suggestions: [
                    { "text": "form-strings.condominium-or-tenancy.condominium", key: "condominium" },
                    { "text": "form-strings.condominium-or-tenancy.tenancy", key: "tenancy" },
                ],
                next: {
                    valueSource: ["value"],
                    cases: {
                        "condominium": 7,
                        "tenancy": 16,
                        default: 0//submit_phase_index
                    },
                    autoNext: {
                        allAutoNext: false,
                        shouldAutoNext: ["tenancy"],
                    }
                }
            }
        },
        5: {
            id: "insuranceInfo",
            title: "form-strings.private-person-info.help-with",
            operation: {
                type: "LIST-TEXT-INPUT",
                options: [
                    {
                        label: "form-strings.private-person-info.insurance-number",
                        key: 'insuranceNumber',
                        maxLen: 15,
                        validationType: 'asNumeric',
                        inputMode: 'numeric'
                    },
                    {
                        label: "form-strings.private-person-info.p-number",
                        key: 'pNumber',
                        maxLen: 12,
                        validationType: 'asPNumber',
                        inputMode: 'numeric'
                    },
                    {
                        label: "form-strings.private-person-info.name",
                        //Flipped name/surname on data, so that it is sent into database in reverse (so we do not have conditions in submit code)
                        key: 'surname',
                        maxLen: 20,
                        validationType: "asFreeText",
                        inputMode: "text"
                    },
                    {
                        label: "form-strings.private-person-info.sur-name",
                        //Flipped name/surname on data, so that it is sent into database in reverse (so we do not have conditions in submit code)
                        key: 'name',
                        maxLen: 20,
                        validationType: 'asFreeText',
                        inputMode: "text"
                    },
                    {
                        label: "form-strings.private-person-info.address",
                        key: 'address',
                        maxLen: 40,
                        validationType: 'asAddress',
                        inputMode: "text"
                    },
                    {
                        label: "form-strings.private-person-info.zip-code",
                        key: 'zipCode',
                        maxLen: 6,
                        validationType: 'asAddress',
                        inputMode: "numeric"
                    },
                    {
                        label: "form-strings.private-person-info.city",
                        key: 'city',
                        maxLen: 40,
                        validationType: 'asAddress',
                        inputMode: 'text'
                    },
                ],
                next: {
                    valueSource: [],
                    cases: {
                        default: 6
                    }
                }
            }
        },
        6: {
            id: "contactInfo",
            title: "form-strings.contact.help-with",
            operation: {
                type: "LIST-TEXT-INPUT",
                options: [
                    {
                        label: "form-strings.contact.contact-person",
                        key: 'contactPerson',
                        maxLen: 40,
                        validationType: 'asFreeText',
                        inputMode: "text"
                    },
                    {
                        label: "form-strings.contact.phone-number",
                        key: 'phoneNumber',
                        maxLen: 12,
                        validationType: 'asPhone',
                        inputMode: 'tel'
                    },
                    {
                        label: "form-strings.contact.alt-phone-number",
                        key: 'altPhoneNumber',
                        maxLen: 12,
                        validationType: 'none',
                        inputMode: 'tel'
                    },
                    {
                        label: "form-strings.contact.email",
                        key: 'email',
                        maxLen: 80,
                        validationType: 'asEmail',
                        inputMode: 'email'
                    }
                ],
                next: {
                    valueSource: [],
                    cases: {
                        default: submit_phase_index
                    }
                }
            }
        },
        7: {
            id: "pestType",
            title: "form-strings.pests.help-with",
            operation: {
                type: "LIST-INPUT",
                description: "form-strings.pests.choice",
                suggestions: [
                    { "text": "form-strings.pests.MYR", key: "MYR" },
                    { "text": "form-strings.pests.MOSS", key: "MÖS" },
                    { "text": "form-strings.pests.SIL", key: "SIL" },
                    { "text": "form-strings.pests.MAL", key: "MAL" },
                    { "text": "form-strings.pests.MOT", key: "MOT" },
                    { "text": "form-strings.pests.FLU", key: "FLU" },
                    { "text": "form-strings.pests.KAC", key: "KAC" },
                ],
                next: {
                    valueSource: ["value"],
                    cases: {
                        default: 20
                    },
                    autoNext: {
                        allAutoNext: true,
                        shouldAutoNext: [],
                    }
                }
            }
        },
        8: {
            id: "insuranceChoice",
            title: "form-strings.insurance-info.help-with",
            operation: {
                type: "LIST-INPUT",
                description: "form-strings.insurance-info.choice",
                suggestions: [],
                next: {
                    valueSource: ["value"],
                    cases: {
                        default: 9
                    },
                    autoNext: {
                        allAutoNext: true,
                        shouldAutoNext: [],
                    }
                }
            }
        },
        9: {
            id: "insuranceInfoBo",
            title: "form-strings.private-person-info.help-with",
            operation: {
                type: "LIST-TEXT-INPUT",
                //description: "form-strings.insurance-info.choice",
                options: [
                    {
                        label: "form-strings.private-person-info.insurance-number",
                        key: 'insuranceNumber',
                        maxLen: 15,
                        validationType: 'asNumeric',
                        inputMode: 'numeric'
                    },
                    {
                        label: "form-strings.private-person-info.org-number",
                        key: 'orgNumber',
                        maxLen: 10,
                        validationType: 'asNumeric',
                        inputMode: "numeric"
                    },
                    {
                        label: "form-strings.private-person-info.org-name",
                        key: 'name',
                        maxLen: 40,
                        validationType: 'asFreeText',
                        inputMode: "text"
                    },
                    {
                        label: "form-strings.private-person-info.apartment-number",
                        key: 'apartNum',
                        maxLen: 4,
                        validationType: 'asNumeric',
                        inputMode: "numeric"
                    },
                    {
                        label: "form-strings.private-person-info.address",
                        key: 'address',
                        maxLen: 40,
                        validationType: 'asAddress',
                        inputMode: "text"
                    },
                    {
                        label: "form-strings.private-person-info.zip-code",
                        key: 'zipCode',
                        maxLen: 6,
                        validationType: 'asAddress',
                        inputMode: "numeric"
                    },
                    {
                        label: "form-strings.private-person-info.city",
                        key: 'city',
                        maxLen: 40,
                        validationType: 'asAddress',
                        inputMode: 'text'
                    }
                ],
                next: {
                    valueSource: [],
                    cases: {
                        default: 6
                    }
                }
            }
        },
        10: {
            id: "pestType",
            title: "form-strings.pests.help-with",
            operation: {
                type: "LIST-INPUT",
                description: "form-strings.pests.choice",
                suggestions: [
                    { "text": "form-strings.pests.MYR", key: "MYR" },
                    { "text": "form-strings.pests.MOSS", key: "MÖS" },
                    { "text": "form-strings.pests.SIL", key: "SIL" },
                    { "text": "form-strings.pests.MAL", key: "MAL" },
                    { "text": "form-strings.pests.MOT", key: "MOT" },
                    { "text": "form-strings.pests.FLU", key: "FLU" },
                    { "text": "form-strings.pests.KAC", key: "KAC" },
                ],
                next: {
                    valueSource: ["value"],
                    cases: {
                        default: 21
                    },
                    autoNext: {
                        allAutoNext: true,
                        shouldAutoNext: [],
                    }
                }
            }
        },
        11: {
            id: "pestType",
            title: "form-strings.pests.help-with",
            operation: {
                type: "LIST-INPUT",
                description: "form-strings.pests.choice",
                suggestions: [
                    { "text": "form-strings.pests.MYR", key: "MYR" },
                    { "text": "form-strings.pests.MOSS", key: "MÖS" },
                    { "text": "form-strings.pests.SIL", key: "SIL" },
                    { "text": "form-strings.pests.MAL", key: "MAL" },
                    { "text": "form-strings.pests.MOT", key: "MOT" },
                    { "text": "form-strings.pests.FLU", key: "FLU" },
                    { "text": "form-strings.pests.KAC", key: "KAC" },
                ],
                next: {
                    valueSource: ["value"],
                    cases: {
                        default: 22
                    },
                    autoNext: {
                        allAutoNext: true,
                        shouldAutoNext: [],
                    }
                }
            }
        },
        12: {
            id: "pestType",
            title: "form-strings.pests.help-with",
            operation: {
                type: "LIST-INPUT",
                description: "form-strings.pests.choice",
                suggestions: [
                    { "text": "form-strings.pests.MYR", key: "MYR" },
                    { "text": "form-strings.pests.MOSS", key: "MÖS" },
                    { "text": "form-strings.pests.SIL", key: "SIL" },
                    { "text": "form-strings.pests.MAL", key: "MAL" },
                    { "text": "form-strings.pests.MOT", key: "MOT" },
                    { "text": "form-strings.pests.FLU", key: "FLU" },
                    { "text": "form-strings.pests.KAC", key: "KAC" },
                ],
                next: {
                    valueSource: ["value"],
                    cases: {
                        default: 23
                    },
                    autoNext: {
                        allAutoNext: true,
                        shouldAutoNext: [],
                    }
                }
            }
        },
        13: {
            id: "onYesAgreementNomor",
            title: "form-strings.private-person-info.help-with",
            operation: {
                type: "LIST-TEXT-INPUT",
                options: [
                    {
                        label: "form-strings.private-person-info.org-number2",
                        key: 'orgNumber',
                        maxLen: 10,
                        validationType: 'none',
                        inputMode: "numeric"
                    },
                    {
                        label: "general.given-name",
                        key: 'name',
                        maxLen: 20,
                        validationType: 'asFreeText',
                        inputMode: "text"
                    },
                    {
                        label: "general.surname",
                        key: 'surname',
                        maxLen: 20,
                        validationType: 'asFreeText',
                        inputMode: "text"
                    },
                    {
                        label: "form-strings.private-person-info.address",
                        key: 'address',
                        maxLen: 40,
                        validationType: 'asAddress',
                        inputMode: "text"
                    },
                    {
                        label: "form-strings.private-person-info.zip-code",
                        key: 'zipCode',
                        maxLen: 6,
                        validationType: 'asAddress',
                        inputMode: "numeric"
                    },
                    {
                        label: "form-strings.private-person-info.city",
                        key: 'city',
                        maxLen: 40,
                        validationType: 'asAddress',
                        inputMode: 'text'
                    }
                ],
                next: {
                    valueSource: [],
                    cases: {
                        default: 6
                    }
                }
            }
        },
        14: {
            id: "insuranceChoice",
            title: "form-strings.insurance-info.help-with",
            operation: {
                type: "LIST-INPUT",
                description: "form-strings.insurance-info.choice",
                suggestions: [],
                next: {
                    valueSource: ["value"],
                    cases: {
                        default: 15
                    },
                    autoNext: {
                        allAutoNext: true,
                        shouldAutoNext: [],
                    }
                }
            }
        },
        15: {
            id: "insuranceInfoMuniOrRealEstate",
            title: "form-strings.private-person-info.help-with",
            operation: {
                type: "LIST-TEXT-INPUT",
                options: [
                    {
                        label: "form-strings.private-person-info.insurance-number",
                        key: 'insuranceNumber',
                        maxLen: 15,
                        validationType: 'asNumeric',
                        inputMode: 'numeric'
                    },
                    {
                        label: "form-strings.private-person-info.org-number2",
                        key: 'orgNumber',
                        maxLen: 10,
                        validationType: 'none',
                        inputMode: "numeric"
                    },
                    {
                        label: "general.given-name",
                        key: 'name',
                        maxLen: 20,
                        validationType: "asFreeText",
                        inputMode: "text"
                    },
                    {
                        label: "general.surname",
                        key: 'surname',
                        maxLen: 20,
                        validationType: 'asFreeText',
                        inputMode: "text"
                    },
                    {
                        label: "form-strings.private-person-info.apartment-number",
                        key: 'apartNum',
                        maxLen: 4,
                        validationType: 'asNumeric',
                        inputMode: "numeric"
                    },
                    {
                        label: "form-strings.private-person-info.address",
                        key: 'address',
                        maxLen: 40,
                        validationType: 'asAddress',
                        inputMode: "text"
                    },
                    {
                        label: "form-strings.private-person-info.zip-code",
                        key: 'zipCode',
                        maxLen: 6,
                        validationType: 'asAddress',
                        inputMode: "numeric"
                    },
                    {
                        label: "form-strings.private-person-info.city",
                        key: 'city',
                        maxLen: 40,
                        validationType: 'asAddress',
                        inputMode: 'text'
                    }
                ],
                next: {
                    valueSource: [],
                    cases: {
                        default: 6
                    }
                }
            }
        },
        16: {
            id: "pestType",
            title: "form-strings.pests.help-with",
            operation: {
                type: "LIST-INPUT",
                description: "form-strings.pests.choice",
                suggestions: [
                    { "text": "form-strings.pests.MYR", key: "MYR" },
                    { "text": "form-strings.pests.MOSS", key: "MÖS" },
                    { "text": "form-strings.pests.SIL", key: "SIL" },
                    { "text": "form-strings.pests.MAL", key: "MAL" },
                    { "text": "form-strings.pests.MOT", key: "MOT" },
                    { "text": "form-strings.pests.FLU", key: "FLU" },
                    { "text": "form-strings.pests.KAC", key: "KAC" },
                ],
                next: {
                    valueSource: ["value"],
                    cases: {
                        default: 24
                    },
                    autoNext: {
                        allAutoNext: true,
                        shouldAutoNext: [],
                    }
                }
            }
        },
        17: {
            id: "municipalityOrCompany",
            title: "form-strings.municipality-or-company.help-with",
            operation: {
                type: "LIST-INPUT",
                description: "form-strings.municipality-or-company.choice",
                suggestions: [],
                next: {
                    valueSource: ["value"],
                    cases: {
                        default: 18
                    },
                    autoNext: {
                        allAutoNext: true,
                        shouldAutoNext: [],
                    }
                }
            }
        },
        18: {
            id: "insuranceInfoMuniOrRealEstate",
            title: "form-strings.private-person-info.help-with",
            operation: {
                type: "LIST-TEXT-INPUT",
                options: [
                    {
                        label: "form-strings.private-person-info.apartment-number",
                        key: 'apartNum',
                        maxLen: 4,
                        validationType: 'asNumeric',
                        inputMode: "numeric"
                    },
                    {
                        label: "form-strings.private-person-info.help-with-address",
                        key: 'address',
                        maxLen: 40,
                        validationType: 'asAddress',
                        inputMode: "text"
                    },
                    {
                        label: "form-strings.private-person-info.zip-code",
                        key: 'zipCode',
                        maxLen: 6,
                        validationType: 'asAddress',
                        inputMode: "numeric"
                    },
                    {
                        label: "form-strings.private-person-info.city",
                        key: 'city',
                        maxLen: 40,
                        validationType: 'asAddress',
                        inputMode: 'text'
                    }
                ],
                next: {
                    valueSource: [],
                    cases: {
                        default: 6
                    }
                }
            }
        },
        19: {
            id: "numOfRooms",
            title: "form-strings.pests.help-with",
            operation: {
                type: "LIST-TEXT-INPUT",
                options: [
                    {
                        label: "form-strings.pests.num-of-rooms",
                        key: 'numOfRooms',
                        maxLen: 2,
                        validationType: 'none',
                        inputMode: 'numeric'
                    }
                ],
                next: {
                    valueSource: [],
                    cases: {
                        default: 2
                    }
                }
            }
        },
        20: {
            id: "numOfRooms",
            title: "form-strings.pests.help-with",
            operation: {
                type: "LIST-TEXT-INPUT",
                options: [
                    {
                        label: "form-strings.pests.num-of-rooms",
                        key: 'numOfRooms',
                        maxLen: 2,
                        validationType: 'none',
                        inputMode: 'numeric'
                    }
                ],
                next: {
                    valueSource: [],
                    cases: {
                        default: 8
                    }
                }
            }
        },
        21: {
            id: "numOfRooms",
            title: "form-strings.pests.help-with",
            operation: {
                type: "LIST-TEXT-INPUT",
                options: [
                    {
                        label: "form-strings.pests.num-of-rooms",
                        key: 'numOfRooms',
                        maxLen: 2,
                        validationType: 'none',
                        inputMode: 'numeric'
                    }
                ],
                next: {
                    valueSource: [],
                    cases: {
                        default: 1
                    }
                }
            }
        },
        22: {
            id: "numOfRooms",
            title: "form-strings.pests.help-with",
            operation: {
                type: "LIST-TEXT-INPUT",
                options: [
                    {
                        label: "form-strings.pests.num-of-rooms",
                        key: 'numOfRooms',
                        maxLen: 2,
                        validationType: 'none',
                        inputMode: 'numeric'
                    }
                ],
                next: {
                    valueSource: [],
                    cases: {
                        default: 14
                    }
                }
            }
        },
        23: {
            id: "numOfRooms",
            title: "form-strings.pests.help-with",
            operation: {
                type: "LIST-TEXT-INPUT",
                options: [
                    {
                        label: "form-strings.pests.num-of-rooms",
                        key: 'numOfRooms',
                        maxLen: 2,
                        validationType: 'none',
                        inputMode: 'numeric'
                    }
                ],
                next: {
                    valueSource: [],
                    cases: {
                        default: 13
                    }
                }
            }
        },
        24: {
            id: "numOfRooms",
            title: "form-strings.pests.help-with",
            operation: {
                type: "LIST-TEXT-INPUT",
                options: [
                    {
                        label: "form-strings.pests.num-of-rooms",
                        key: 'numOfRooms',
                        maxLen: 2,
                        validationType: 'none',
                        inputMode: 'numeric'
                    }
                ],
                next: {
                    valueSource: [],
                    cases: {
                        default: 17
                    }
                }
            }
        },
        25: {
            id: "insuranceInfoMuniOrRealEstate",
            title: "form-strings.private-person-info.help-with",
            operation: {
                type: "LIST-TEXT-INPUT",
                options: [
                    {
                        label: "form-strings.private-person-info.org-number2",
                        key: 'orgNumber',
                        maxLen: 10,
                        validationType: 'asNumeric',
                        inputMode: "numeric"
                    },
                    {
                        label: "form-strings.private-person-info.company-name",
                        key: 'name',
                        maxLen: 40,
                        validationType: "asFreeText",
                        inputMode: "text"
                    },
                    {
                        label: "form-strings.private-person-info.address",
                        key: 'address',
                        maxLen: 40,
                        validationType: 'asAddress',
                        inputMode: "text"
                    },
                    {
                        label: "form-strings.private-person-info.zip-code",
                        key: 'zipCode',
                        maxLen: 6,
                        validationType: 'asAddress',
                        inputMode: "numeric"
                    },
                    {
                        label: "form-strings.private-person-info.city",
                        key: 'city',
                        maxLen: 40,
                        validationType: 'asAddress',
                        inputMode: 'text'
                    }
                ],
                next: {
                    valueSource: [],
                    cases: {
                        default: 6
                    }
                }
            }
        },
        26: {
            id: "pestType",
            title: "form-strings.pests.help-with",
            operation: {
                type: "LIST-INPUT",
                description: "form-strings.pests.choice",
                suggestions: [
                    { "text": "form-strings.pests.MYR", key: "MYR" },
                    { "text": "form-strings.pests.MOSS", key: "MÖS" },
                    { "text": "form-strings.pests.SIL", key: "SIL" },
                    { "text": "form-strings.pests.MAL", key: "MAL" },
                    { "text": "form-strings.pests.MOT", key: "MOT" },
                    { "text": "form-strings.pests.FLU", key: "FLU" },
                    { "text": "form-strings.pests.KAC", key: "KAC" },
                ],
                next: {
                    valueSource: ["value"],
                    cases: {
                        default: 27
                    },
                    autoNext: {
                        allAutoNext: true,
                        shouldAutoNext: [],
                    }
                }
            }
        },
        27: {
            id: "numOfRooms",
            title: "form-strings.pests.help-with",
            operation: {
                type: "LIST-TEXT-INPUT",
                options: [
                    {
                        label: "form-strings.pests.num-of-rooms",
                        key: 'numOfRooms',
                        maxLen: 2,
                        validationType: 'none',
                        inputMode: 'numeric'
                    }
                ],
                next: {
                    valueSource: [],
                    cases: {
                        default: 25
                    }
                }
            }
        },
    }
}